import { extend } from "lodash";
import React from "react";
import { createRoot } from "react-dom/client";

export default function (ComponentClass, elementId) {
  const el = document.getElementById(elementId);
  const props = {};
  return nextProps => {
    extend(props, nextProps);
    const root = createRoot(el);
    root.render(React.createElement(ComponentClass, props));
  };
}
